import { TextField } from "@mui/material";
import ReactInputMask from 'react-input-mask';
import { useState } from 'react';

interface Props {
    label: string;
    value: string;
    name: string;
    className?: string;
    error?: any;
    hasError?: boolean;
    disabled?: boolean;
    handleBlur?: (e: any) => void;
    handleChange?: (e: any) => void;
  }

  export const InputWeight = ({
    label,
    value,
    name,
    className,
    error,
    hasError,
    handleBlur,
    handleChange,
    disabled,
  }: Props) => {
    const [mask, setMask] = useState('9.999,999');//Inicialmente o formato é até 10000kg

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value.replace(/\D/g, '');
        if(inputValue.length < 5){
            setMask('9,9999');
        } else if (inputValue.length < 7){
            setMask('999,9999');
        } else{
            setMask('9.999,999');
        }

        if(handleChange){
            handleChange(e); //Chama a função handleChange passada via props
        }
    };

    return (
      <ReactInputMask
        disabled={disabled}
        id={name}
        mask={mask}
        maskChar=''
        onBlur={handleBlur}
        onChange={handleInputChange}
      >
        {/*// @ts-expect-error - .*/}
        {() => (
          <TextField
            size='small'
            disabled={disabled}
            label={label}
            //InputLabelProps={{ shrink: true }}
            name={name}
            className={className}
            error={hasError}
            helperText={error}
          />
        )}
      </ReactInputMask>
    );
  };